import { registerTab } from "lib/@components/tabs"
import { Lazy } from "lib/make-lazy"

/**
 * Access Overrides (FIQ-1926) — a top-level SFG20 Admin tab.
 *
 * Sits alongside Companies and Users rather than under System Admin: it is about client and
 * user access, not server configuration.
 *
 * `admin-advanced` matches the Access tab that creates these overrides — the read-only report
 * must not be harder to reach than the write that produces the rows.
 */
registerTab({
    tab: "sfg20AdminTabs",
    id: "accessOverrides",
    title: "Access Overrides",
    demands: "admin-advanced",
    content: <Lazy priority={6} importer={() => import("./access-overrides.js")} extract={"AccessOverrides"} />,
})
